import React, {useEffect, useState} from 'react';

import AiBotIcon from '../../../../../assets/svgComponents/AiBotIcon';

import ToolTipComponent from '../../toolTipComponent';

import utilsService from '../../../../../services/utilsService';

import './aiBotPillComponent.css';

const AiBotPillComponent = ({
  assistantName = null,
  hideToolTip = false,
  widgetName = null,
  toolTipPosition = 'right',
}) => {
  const [showToolTip, setShowToolTip] = useState(false);
  const [toolTipTxt, setToolTipTxt] = useState('');

  useEffect(() => {
    const toolTipTxt = `Widget: ${widgetName} \n Handle: ${utilsService.getAssistantName(assistantName)}`;
    setToolTipTxt(toolTipTxt);
  }, [widgetName, assistantName]);

  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  return (
    <div
      className="et-v2-ai-bot-pill-container"
      onMouseEnter={handleToolTip}
      onMouseLeave={handleToolTip}>
      <AiBotIcon />
      {!hideToolTip && showToolTip && (
        <ToolTipComponent
          toolTipPosition={toolTipPosition}
          toolTipTxt={toolTipTxt}
        />
      )}
    </div>
  );
};

export default AiBotPillComponent;
